import * as React from 'react';
import styled from 'styled-components';

var ScreenReaderOnlyStyled = /*#__PURE__*/styled.span.withConfig({
  displayName: "ScreenReaderOnly__ScreenReaderOnlyStyled",
  componentId: "sc-szxtre-0"
})(["position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0;"]);
var ScreenReaderOnly = function ScreenReaderOnly(props) {
  return /*#__PURE__*/React.createElement(ScreenReaderOnlyStyled, props, props.children);
};
ScreenReaderOnly.displayName = 'ScreenReaderOnly';

export { ScreenReaderOnly };
//# sourceMappingURL=ScreenReaderOnly.js.map
